<svelte:options accessors />

<script lang="ts">
  import { createEventDispatcher, getContext } from 'svelte';

  import Drawer from '@/comps-sdk/components/drawer';
  import { EZoneRoleSelect, type IZoneRoleSelect } from '@/comps-sdk/interface';

  import ZoneRoleContent from './zone-role-content.svelte';

  const { hooks, slots } = getContext(EZoneRoleSelect.CONTEXT_INTERFACE_KEY) as IZoneRoleSelect.CompContextInterface;

  const titleMap: IZoneRoleSelect.TitleMap = {
    first: '',
    client: '选择客户端',
    area: '选择区服',
    role: '选择角色',
  };

  export let props: IZoneRoleSelect.ZoneRoleSelectProps;

  export const show = () => {
    isShow = true;
  };

  let isShow = true;
  let isInit = false;
  let panelTag = 'first';
  let panelTagStack = ['first'];
  const innerProps: IZoneRoleSelect.ZoneRoleSelectProps = props;

  const dispatch = createEventDispatcher();
  const updateProps = (key: keyof IZoneRoleSelect.ZoneRoleSelectProps, value: unknown) => {
    innerProps[key] = value as never;
  };

  $: drawerTitle = titleMap[panelTag];

  const getHooksByType = (hookType: EZoneRoleSelect.HOOKS) => hooks.filter(({ type }) => type === hookType).map(({ check }) => check(props, updateProps));

  const handleConfirm = async (result: IZoneRoleSelect.ZoneRoleResult) => {
    const confirmHooks = getHooksByType(EZoneRoleSelect.HOOKS.beforeConfirm);

    const doConfirm = () => {
      if (!props.confirmCb) {
        dispatch('confirm', result);
        return;
      }
      props.confirmCb(result);
    };

    if (confirmHooks.length > 0) {
      await Promise.all(confirmHooks)
        .then(() => {
          doConfirm();
        })
        .catch((err) => {
          handleClose();
          console.error('[comps-sdk:zone-role-select:handleConfirm] err: ', err);
        });
      return;
    }

    doConfirm();
  };

  const handleClose = (isConfirm = false) => {
    isShow = false;
    if (!isConfirm) {
      if (!props.closeCb) {
        dispatch('close');
        return;
      }

      props.closeCb();
    }
  };

  const handlePanelChange = (detail: { panelTag: string; panelTagStack: Array<string> }) => {
    panelTag = detail.panelTag;
    panelTagStack = detail.panelTagStack;
  };

  const handleBack = () => {
    if (panelTagStack.length) {
      panelTagStack.pop();
      panelTagStack = panelTagStack;
      panelTag = panelTagStack[panelTagStack.length - 1];
    }
    dispatch('back');
  };

  const init = async () => {
    const initHooks = getHooksByType(EZoneRoleSelect.HOOKS.beforeInit);

    if (initHooks.length > 0) {
      await Promise.all(initHooks)
        .then(() => {
          isInit = true;
        })
        .catch((e) => {
          console.error('zone-role-select initHooks throw error: ', e);
          handleClose();
        });
      return;
    }

    isInit = true;
  };

  init();
</script>

<Drawer
  value={isShow && isInit}
  title={drawerTitle}
  on:input={(e) => {
    handleClose(e.detail);
  }}
  on:back={handleBack}
>
  <ZoneRoleContent
    props={{ ...innerProps, panelTag, panelTagStack }}
    on:confirm={(e) => {
      handleConfirm(e.detail);
    }}
    on:close={(e) => {
      handleClose(e.detail);
    }}
    on:panel-change={(e) => {
      handlePanelChange(e.detail);
    }}
    on:back={handleBack}
  >
    <svelte:fragment slot="beforeConfirmBtn">
      {#if slots.beforeConfirmBtn.check(props)}
        <svelte:component this={slots.beforeConfirmBtn.slot} />
      {/if}
    </svelte:fragment>
  </ZoneRoleContent>
</Drawer>
